module.exports = __webpack_public_path__ + "assets/img/label1.bc24deb7.svg";